<ng-container *adaptLoadingUntilFirstEmit="let allGuidanceMaterials of allGuidanceMaterials$">
    @if (processStepGuidanceMaterials.length > 0) {
        <dx-list [dataSource]="processStepGuidanceMaterials"
                 [hoverStateEnabled]="false"
                 [activeStateEnabled]="false"
                 [focusStateEnabled]="false"
                 [allowItemDeleting]="true"
                 height="auto"
                 (onItemReordered)="updateOrdinals($event)"
                 (onItemDeleted)="removeProcessStepGuidanceMaterial($event)">
            <dxo-list-item-dragging [allowReordering]="true"></dxo-list-item-dragging>
            <adapt-display-guidance-material *dxTemplate="let item of 'item'"
                                             [guidanceMaterial]="item.guidanceMaterial"
                                             [showDescription]="false"></adapt-display-guidance-material>
        </dx-list>
    }
    <dx-select-box class="m-2"
                   [dataSource]="selectableGuidanceMaterials"
                   displayExpr="name"
                   [searchEnabled]="true"
                   (valueChange)="addGuidanceMaterial($event)"></dx-select-box>
    <button class="ms-2 btn btn-link"
            [adaptBlockingClick]="createAndAddGuidanceMaterial"
            adaptButtonIcon="add">Add new guidance material</button>
</ng-container>
